import { Injectable } from '@angular/core';
import { SidenavItemInterface } from '../interfaces/side-nav-items.interface';
import { SidenavModel } from '../models/sidenav.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SideNavService {
  private mainLinks: SidenavModel[] = [];

  private selectedMainLink$ = new BehaviorSubject<SidenavModel | undefined>(
    this.mainLinks.find((link) => link.expanded),
  );

  private rootSidenavItem: SidenavModel = new SidenavModel({
    id: 'root',
    items: [],
    label: 'ROOT',
    icon: '',
  });

  mainLinks$ = new BehaviorSubject<SidenavModel[]>([]);

  constructor() {}

  get currentActivatedMainLink() {
    return this.selectedMainLink$.value;
  }

  /** Get all main links */
  getMainLinks(): SidenavModel[] {
    return this.mainLinks;
  }

  /** Reset selectedMainLink */
  resetSideNav() {
    this.selectedMainLink$.value?.unExpandAllItems();
    this.selectedMainLink$.next(undefined);
  }

  /** Set Main links */
  setMainLinks(mainLinks: SidenavItemInterface[]): void {
    this.mainLinks = this.rootSidenavItem.setMainLinks(mainLinks);
    this.mainLinks$.next(this.mainLinks);
  }

  /** Get current selected main item as observable */
  getSelectedMainItem(): Observable<SidenavModel | undefined> {
    return this.selectedMainLink$.asObservable();
  }

  /** Set selected main link based on id or routerLink */
  setSelectedMainLink(
    id: string | null = null,
    routerLink?: string | string[],
  ): void {
    routerLink = Array.isArray(routerLink)
      ? routerLink
      : routerLink?.split('/');
    let selectedMainLink: SidenavModel | undefined;

    if (id) {
      selectedMainLink = this.setSelectMainItemWithId(id);
    } else if (routerLink) {
      selectedMainLink = this.setSelectMainItemWithoutId(routerLink);
    }

    this.selectedMainLink$.next(selectedMainLink);
  }

  /** Select main item without ID (based on routerLink) */
  private setSelectMainItemWithoutId(
    routerLink: string[],
    
  ): SidenavModel | undefined {
    let selectedMainLink = this.mainLinks.find((link) => {
      if (link.getMatchRate(routerLink)) {
        return true;
      } else {
        return link.isShown && link.expanded;
      }
    });

    if (!selectedMainLink) {
      selectedMainLink = this.mainLinks.find((link) => link.isShown);
      selectedMainLink && (selectedMainLink.expanded = true);
    }

    return selectedMainLink;
  }

  /** Select main item with ID */
  private setSelectMainItemWithId(id: string): SidenavModel | undefined {
    const selectedMainLink = this.mainLinks.find((link) => link.id === id);
    selectedMainLink?.toggleExpandItem();
    return selectedMainLink;
  }

  /** Add submenu items to a main link */
  addSubMenuItems(id: string, items: SidenavItemInterface[]): void {
    const mainLink = this.mainLinks.find((link) => link.id === id);
    mainLink?.setSubMainLinks(items);
    this.mainLinks$.next(this.mainLinks);
  }

  /** Expand or collapse an item */
  toggleExpandItem(item: SidenavModel) {
    if (item.expanded) {
      return item.unExpandAllItems();
    }
    this.rootSidenavItem.unExpandAllItems();
    item.toggleExpandItem();
  }

  /** Match router link with sidenav item and activate */
  searchMenuActivatedRoute(routerLink: string | string[]): void {
    const routeArray = Array.isArray(routerLink)
      ? routerLink
      : routerLink.split('/');
    this.rootSidenavItem.activateItem(routeArray);
    this.setSelectedMainLink(null, routeArray);
  }
}
